import { icons } from '@chillibean/component-library/legacy';
import PropTypes from 'prop-types';

import CheckboxField from '../../../../../../primitives/form/CheckboxField/CheckboxField';
import withInputLabel from '../../../../../../primitives/form/hoc/withInputLabel';
import withMultipleOptions from '../../../../../../primitives/form/hoc/withMultipleOptions';
import RadioField from '../../../../../../primitives/form/RadioField/RadioField';
import SelectField from '../../../../../../primitives/form/SelectField/SelectField';
import TextField from '../../../../../../primitives/form/TextField/TextField';

const RadioWithOptions = withMultipleOptions(RadioField);
const RadioWithLabel = withInputLabel(RadioWithOptions);
const CheckBoxWithOptions = withMultipleOptions(CheckboxField);
const CheckboxWithLabel = withInputLabel(CheckBoxWithOptions);

function AddAFieldDisplay(props) {
  const { fieldValues, isActive } = props;

  const isCollapsed = () => (isActive ? '' : 'addAField__display--collapsed');
  const isDisabled = () => !fieldValues.enabled && 'addAField__close--disabled';

  switch (fieldValues ? fieldValues.field_type : null) {
    case 'single_line':
      return (
        <div className={`addAField__display addAField__display--textbox ${isCollapsed()} ${isDisabled()}`}>
          <div className="form__group">
            <TextField
              showError={false}
              errorMessage=""
              fieldID={`display_${fieldValues.position}_single_line`}
              fieldName="Single line"
              fieldRequired={false}
              value={fieldValues.title}
              disabled
              autoComplete="off"
            />
          </div>
        </div>
      );

    case 'descriptive':
      return (
        <div className={`addAField__display addAField__display--textbox ${isCollapsed()} ${isDisabled()}`}>
          <div className="form__group">
            <TextField
              showError={false}
              errorMessage=""
              fieldID={`display_${fieldValues.position}_descriptive`}
              fieldName="Descriptive"
              fieldRequired={false}
              value={fieldValues.title}
              disabled
              autoComplete="off"
            />
            <div className="addAField__display--resizeIcon">{icons.resize(18, 18)}</div>
          </div>
        </div>
      );

    case 'checkbox':
      return (
        <div
          className={`addAField__display addAField__display--textbox ${
            !isActive && 'addAField__close--checkbox'
          } ${isDisabled()}`}
        >
          <div className="form__group ">
            <TextField
              showError={false}
              errorMessage=""
              fieldID={`display_${fieldValues.position}_checkbox`}
              fieldName="Checkbox"
              fieldRequired={false}
              value={fieldValues.title}
              disabled
              autoComplete="off"
            />
            {!isActive && (
              <CheckboxWithLabel
                showError={false}
                fieldName={`display_${fieldValues.position}_checkbox`}
                fieldID={`display_${fieldValues.position}_checkbox`}
                fieldRequired={false}
                options={fieldValues.options}
              />
            )}
          </div>
        </div>
      );

    case 'radio':
      return (
        <div
          className={`addAField__display addAField__display--textbox ${
            !isActive && 'addAField__close--checkbox'
          } ${isDisabled()}`}
        >
          <div className="form__group ">
            <TextField
              showError={false}
              errorMessage=""
              fieldID={`display_${fieldValues.position}_radio`}
              fieldName="Radio"
              fieldRequired={false}
              value={fieldValues.title}
              disabled
              autoComplete="off"
            />
            {!isActive && (
              <RadioWithLabel
                showError={false}
                fieldName={`display_${fieldValues.position}_radio`}
                fieldID={`display_${fieldValues.position}_radio`}
                fieldRequired={false}
                options={fieldValues.options}
                isOtherEnabled={fieldValues.other_enabled}
                otherFieldLabel={fieldValues.other_field}
              />
            )}
          </div>
        </div>
      );

    case 'date':
      return (
        <div className={`addAField__display addAField__display--textbox ${isCollapsed()} ${isDisabled()}`}>
          <div className="form__group ">
            <TextField
              showError={false}
              errorMessage=""
              fieldID={`display_${fieldValues.position}_date`}
              fieldName="Date Picker"
              fieldRequired={false}
              value={fieldValues.title}
              disabled
              autoComplete="off"
            />
            <div className="addAField__display--dateIcon">{!isActive && icons.calendar(28, 28)}</div>
          </div>
        </div>
      );

    case 'dropdown':
      return (
        <div className={`addAField__display addAField__display--textbox ${isCollapsed()} ${isDisabled()}`}>
          <div className="form__group form__group--dropdown">
            <SelectField
              showError={false}
              errorMessage=""
              fieldID={`display_${fieldValues.position}_dropdown`}
              fieldName="Dropdown"
              fieldRequired={false}
              value={fieldValues.title}
              disabled
              autoComplete="off"
              options={[]}
            />
          </div>
        </div>
      );

    default:
      return <div />;
  }
}

export default AddAFieldDisplay;

AddAFieldDisplay.propTypes = {
  fieldValues: PropTypes.shape({
    enabled: PropTypes.bool,
    field_type: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.string),
    other_enabled: PropTypes.bool,
    other_field: PropTypes.string,
    position: PropTypes.number,
    title: PropTypes.string,
  }),
  isActive: PropTypes.bool,
};
